{"browse_shop":"Procurar na loja","go_to_shop":"Ir para a loja","no_orders_found":"Não foram encontradas encomendas","title":"Encomendas"}